import type { FlagKey, FlagRecord } from "./flags";
import type { BackofficeUser } from "./types";

const BACKOFFICE_FRONTEND_TAG = "backoffice-frontend";

export const fetchActiveFlagKeys = async (signal?: AbortSignal): Promise<FlagKey[]> => {
  const res = await fetch(`${import.meta.env.VITE_FLAGR_URL}/flags?enabled=true&tags=${BACKOFFICE_FRONTEND_TAG}`, {
    signal
  });
  const data = await res.json();
  const result = data.map((flag: { key: FlagKey }) => flag.key);
  return result;
};

type EvaluationResponse = {
  evaluationResults: {
    flagKey: FlagKey;
    variantKey?: string;
  }[];
};

export const fetchEvaluateFlags = async (
  flagKeys: FlagKey[],
  me: BackofficeUser,
  signal?: AbortSignal
): Promise<FlagRecord> => {
  const { externalId: email, department, organization } = me;
  const entityContext: Record<string, string> = { email };

  if (department) {
    entityContext.department = department;
  }

  if (organization) {
    entityContext.organization = organization;
  }

  const res = await fetch(`${import.meta.env.VITE_FLAGR_URL}/evaluation/batch`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    signal,
    body: JSON.stringify({
      enableDebug: false,
      flagKeys,
      entities: [
        {
          entityID: email,
          entityType: "user",
          entityContext
        }
      ]
    })
  });

  const data = (await res.json()) as EvaluationResponse;

  const flagValues = data.evaluationResults.reduce<FlagRecord>((acc, result) => {
    const { flagKey, variantKey } = result;
    // Boolean-style Flagr variants must be real booleans. Leaving "false" as a
    // string makes !!flags[key] truthy and turns off flags on in the UI.
    if (variantKey === "true") {
      acc[flagKey] = true;
    } else if (variantKey === "false") {
      acc[flagKey] = false;
    } else {
      acc[flagKey] = variantKey;
    }
    return acc;
  }, {});

  return flagValues;
};
